export function MetricTile({
  label,
  value,
  accent = 'text-white',
  hint,
}: {
  label: string
  value: string | number
  accent?: string
  hint?: string
}) {
  return (
    <div className="cyber-panel p-5">
      <p className={`font-display text-2xl font-bold ${accent}`}>{value}</p>
      <p className="mt-1 text-xs font-medium uppercase tracking-wide text-white/50">{label}</p>
      {hint && <p className="mt-1 text-xs text-white/40">{hint}</p>}
    </div>
  )
}

export function MetricBar({ label, percent, accent = 'bg-teal-400' }: { label: string; percent: number; accent?: string }) {
  const clamped = Math.max(0, Math.min(100, percent))
  return (
    <div>
      <div className="flex items-center justify-between text-xs text-white/60">
        <span>{label}</span>
        <span className="font-semibold text-white">{clamped}%</span>
      </div>
      <div className="mt-1.5 h-2 w-full overflow-hidden rounded-full bg-white/10">
        <div className={`h-full rounded-full ${accent} transition-all`} style={{ width: `${clamped}%` }} />
      </div>
    </div>
  )
}
